import { render, staticRenderFns } from "./RewardPurchaseModal.vue?vue&type=template&id=7951e70c&scoped=true&"
import script from "./RewardPurchaseModal.vue?vue&type=script&lang=ts&"
export * from "./RewardPurchaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951e70c",
  null
  
)

export default component.exports